const formatDateToCustomString = (dateString) => {
  const date = new Date(dateString); // Convert the string to a Date object
  const day = date
    .toLocaleDateString("fr-FR", { weekday: "short" })
    .replace(/^\w/, (c) => c.toUpperCase()); // Capitalize first letter
  const dayOfMonth = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day} ${dayOfMonth}/${month}/${year} à ${hours}h ${minutes} min`;
};

export default formatDateToCustomString;
